import { SourceTypes } from '../../../constants';
import type {
  TiktokAuthorResponse,
  TiktokSourceValue
} from '../sources/tiktok/types';
import { parseTiktokSource } from '../sources/tiktok/utils/parseTiktokSource';
import type { AuthorAdapter } from '../sources/types';
import { buildProxyURL } from '../utils/buildProxyUrl';
import { getMediaWithProxy } from '../utils/getMediaWithProxy';

export const tiktokProfileAdapter: AuthorAdapter<TiktokAuthorResponse> = {
  isApplicable: (source: TiktokSourceValue) => {
    const isCorrectPlatform = source.platform === SourceTypes.TIKTOK;
    const isCorrectConnectionType = source.connectionType === 'tiktokProfile';

    return !!source.source && isCorrectPlatform && isCorrectConnectionType;
  },

  buildUrl: (source: TiktokSourceValue) => {
    const parsed = parseTiktokSource(source.source!);

    return buildProxyURL({
      apiSource: `v2/tiktok/user-profiles/${parsed}`,
      shouldUseWidgetDataService: false
    });
  },

  mapResponse: (response) => {
    const { data } = response;

    const {
      nickname,
      profileLink,
      isVerified,
      profilePictureUrl,
      username,
      followers,
      following,
      likes
    } = data;

    return {
      name: username,
      username: nickname,
      url: profileLink,
      verified: isVerified,
      image: getMediaWithProxy(profilePictureUrl),
      followers,
      following,
      likes
    };
  }
};
